import { Registry } from 'InterfaceBundle'

/**
 * Style
 */
import './styles/files.scss'

/**
 * Components
 */
import BlFormFieldFile from './components/FormFieldFile.vue'
import BlFileView from './components/FileView.vue'
import BlMultiFileView from './components/MultiFileView.vue'
import BlFileViewDialog from './components/FileViewDialog.vue'
import BlFileExplorer from './components/FileExplorer.vue'
import BlFileMoveDialog from './components/FileMoveDialog.vue'

Registry.components(BlFormFieldFile, BlFileView, BlMultiFileView, BlFileViewDialog, BlFileExplorer, BlFileMoveDialog)

/**
 * Directives
 */

/**
 * Services
 */
import { UploadHelpers as UploadHelpersService } from './services/UploadHelpers.js'

export const UploadHelpers = UploadHelpersService